export const getData = state => state.data || '';

export const getMenuView = state => state.menuView;

export const getHomeContent = state =>
    state.data?.homeContent ||
    '<div class="home-content"><p>This is a placeholder while we wait for the data for the home content.</p></div>';

export const getAbout = state =>
    state.data?.about ||
    '<div class="about-content"><p>This is a placeholder while we wait for the data for the about content.</p></div>';

export const getTrainings = state => state.data?.trainings || [];

export const getEvents = state => state.data?.events || [];

export const getStravaActivity = state => state.data?.stravaActivity || {};

export const getToastContent = state => state.toast.content;

export const getToastOpen = state => state.toast.open;

export const getToastSeverity = state => state.toast.severity || 'success';
